import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports -- CreateSpaceFunnel 전체가 NiceModal 기반. @zep/modals 마이그레이션은 퍼널 단위 별도 작업
import { useModal } from '@ebay/nice-modal-react';
import { zodResolver } from '@hookform/resolvers/zod';
import { ChevronLeftIcon } from '@zep/icons';
import { useViewportDevice } from '@zep/react';
import { MapTemplate } from '@zep/types';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, IconContainer } from '@zep/ui';
import { cn } from '@zep/utils';
import { createSpaceFormDefaults, CreateSpaceSchema, CreateSpaceSchemaType } from '../schema';
import { SpaceCreateSettingContent } from './SpaceCreateSettingContent';
import S from './SpaceCreateSettingModal.module.scss';
export const SpaceCreateSettingModal = (props: SpaceCreateSettingModalProps) => {
  const {
    visible,
    hide,
    remove
  } = useModal();
  const {
    isMobile
  } = useViewportDevice();
  const {
    t
  } = useTranslation(['common']);
  const form = useForm<CreateSpaceSchemaType>({
    resolver: zodResolver(CreateSpaceSchema),
    defaultValues: createSpaceFormDefaults
  });
  return <Dialog maxWidth="400px" drawer={isMobile} open={visible} onClose={hide} afterClose={remove} data-sentry-element="Dialog" data-sentry-component="SpaceCreateSettingModal" data-sentry-source-file="SpaceCreateSettingModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="SpaceCreateSettingModal.tsx" />
      <FormProvider {...form} data-sentry-element="FormProvider" data-sentry-source-file="SpaceCreateSettingModal.tsx">
        <DialogPanel className={S.wrapper} data-sentry-element="DialogPanel" data-sentry-source-file="SpaceCreateSettingModal.tsx">
          <DialogHeader onClose={hide} leftSlot={props.onBack && <IconContainer type="button" onClick={props.onBack}>
                  <ChevronLeftIcon width={20} height={20} aria-label="Go back" />
                </IconContainer>} data-sentry-element="DialogHeader" data-sentry-source-file="SpaceCreateSettingModal.tsx">
            {t('common:createSpaceModal.spaceSetting')}
          </DialogHeader>
          <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="SpaceCreateSettingModal.tsx">
            <SpaceCreateSettingContent isLoadingSubmit={props.isLoading} selectedTemplate={props.selectedTemplate} data-sentry-element="SpaceCreateSettingContent" data-sentry-source-file="SpaceCreateSettingModal.tsx" />
          </DialogContent>
          <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="SpaceCreateSettingModal.tsx">
            <Footer {...props} data-sentry-element="Footer" data-sentry-source-file="SpaceCreateSettingModal.tsx" />
          </DialogFooter>
        </DialogPanel>
      </FormProvider>
    </Dialog>;
};
const Footer = (props: SpaceCreateSettingModalProps) => {
  const {
    isLoading,
    onSubmit
  } = props;
  const {
    watch,
    handleSubmit,
    formState: {
      isDirty,
      errors
    }
  } = useFormContext<CreateSpaceSchemaType>();
  const {
    t
  } = useTranslation(['common']);
  const name = watch('name');
  const isValid = Object.values(errors).length === 0 && name.trim().length > 0;
  return <div className={cn('flex items-center flex-col w-full gap-[1.625rem]', S.footer_content)} data-sentry-component="Footer" data-sentry-source-file="SpaceCreateSettingModal.tsx">
      <span className="text-body-2 text-gray-600">
        {t('common:createSpaceModal.loadingText')}
      </span>
      <Button className="min-w-[120px]" size={'sm'} isFullWidth isLoading={isLoading} disabled={!isValid || !isDirty || isLoading} role={'button'} onClick={handleSubmit(onSubmit, console.error)} data-sentry-element="Button" data-sentry-source-file="SpaceCreateSettingModal.tsx">
        {t('common:createSpaceModal.confirmText')}
      </Button>
    </div>;
};
type SpaceCreateSettingModalProps = {
  isLoading: boolean;
  onSubmit: (data: CreateSpaceSchemaType) => void;
  onBack?: () => void;
  selectedTemplate?: Pick<MapTemplate, 'name' | 'thumbnailUrl' | 'categories'>;
};